<template>

  <form method="get" action="" class="col-12">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group" v-bind:class="(formError.notice && formError.notice.name) ? 'has-danger' :''">
          <label>{{ $t('NAME')}}</label>
          <input type="text" v-model="formData.name" class="form-control secondary" v-bind:placeholder="$t('NAME')">
          <div v-if="formError.notice && formError.notice.name" class="form-control-feedback">{{formError.notice.name}}</div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group" v-bind:class="(formError.notice && formError.notice.surname) ? 'has-danger' :''">
          <label>{{ $t('SURNAME')}}</label>
          <input type="text" v-model="formData.surname" class="form-control secondary" v-bind:placeholder="$t('SURNAME')">
          <div v-if="formError.notice && formError.notice.surname" class="form-control-feedback">{{formError.notice.surname}}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4" v-if="!simple">
        <div class="form-group" v-bind:class="(formError.notice && formError.notice.userGroup) ? 'has-danger' :''">
          <label>{{ $t('USERGROUP') }}</label>
          <select v-model="formData.userGroup" class="form-control secondary">
            <option value="3">{{ $t('OWNER') }}</option>
            <option value="5">{{ $t('ADMINISTRATOR') }}</option>
            <option value="6">{{ $t('NURSE') }}</option>
            <option value="7">{{ $t('TECHNICIAN') }}</option>
            <option value="8">{{ $t('DOCTOR') }}</option>
          </select>
          <div v-if="formError.notice && formError.notice.userGroup" class="form-control-feedback">{{formError.notice.userGroup}}</div>
        </div>
      </div>
      <div v-bind:class="(simple) ? 'col-12' : 'col-md-4'">
        <div class="form-group" v-bind:class="(formError.notice && formError.notice.userEmail) ? 'has-danger' :''">
          <label>{{ $t('USEREMAIL')}}</label>
          <input type="text" v-model="formData.userEmail" class="form-control secondary" v-bind:placeholder="$t('USEREMAIL')">
          <div v-if="formError.notice && formError.notice.userEmail" class="form-control-feedback">{{formError.notice.userEmail}}</div>
        </div>
      </div>
      <div class="col-md-4" v-if="!simple">
        <div class="form-group" v-bind:class="(formError.notice && formError.notice.status) ? 'has-danger' :''">
          <label>{{ $t('STATUS') }}</label>
          <select v-model="formData.status" class="form-control secondary">
            <option value="active">{{ $t('ACTIVE') }}</option>
            <option value="inactive">{{ $t('INACTIVE') }}</option>
          </select>
          <div v-if="formError.notice && formError.notice.status" class="form-control-feedback">{{formError.notice.status}}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4" v-if="formData.id == ''">
        <div class="form-group" v-bind:class="(formError.notice && formError.notice.username) ? 'has-danger' :''">
          <label>{{ $t('USERNAME')}}</label>
          <input type="text" v-model="formData.username" class="form-control secondary" v-bind:placeholder="$t('USERNAME')">
          <div v-if="formError.notice && formError.notice.username" class="form-control-feedback">{{formError.notice.username}}</div>
        </div>
      </div>
      <div v-bind:class="(formData.id == '') ? 'col-md-4' : 'col-md-6'">
        <div class="form-group" v-bind:class="(formError.notice && formError.notice.password) ? 'has-danger' :''">
          <label>{{ $t('PASSWORD')}}</label>
          <input type="password" v-model="formData.password" class="form-control secondary" v-bind:placeholder="$t('PASSWORD')">
          <div v-if="formError.notice && formError.notice.password" class="form-control-feedback">{{formError.notice.password}}</div>
        </div>
      </div>
      <div v-bind:class="(formData.id == '') ? 'col-md-4' : 'col-md-6'">
        <div class="form-group" v-bind:class="(formError.notice && formError.notice.checkpassword) ? 'has-danger' :''">
          <label>{{ $t('REPEATPASSWORD')}}</label>
          <input type="password" v-model="formData.checkpassword" class="form-control secondary" v-bind:placeholder="$t('REPEATPASSWORD')">
          <div v-if="formError.notice && formError.notice.checkpassword" class="form-control-feedback">{{formError.notice.checkpassword}}</div>
        </div>
      </div>
    </div>
    <p class="bg-danger" v-if="formError.error && typeof formError.notice == 'string'">{{formError.notice}}</p>
    <div class="clearfix"></div>
  </form>
</template>

<script>

export default {
  name: 'ControlPanel',
  props: ['formError', 'formData', 'simple']
}

</script>



// WEBPACK FOOTER //
// src/components/EmployeeForm.vue